export const PAYLINE_CURRENCY = {
  EUR: 978,
  USD: 840,
  GBP: 826,
};

export const PAYLINE_ACTIONS = {
  AUTHORIZATION: 100,
  CAPTURE: 101,
  REGISTER_CARD: 108,
  REFUND: 421,
  CANCEL: 501,
};

export const PAYLINE_ERROR_CODES = {
  SUCCESS: '00000',
  INVALID_MERCHANT: '02301',
  INVALID_CONTRACT: '02302',
  INVALID_AMOUNT: '02303',
  CARD_EXPIRED: '02306',
  INVALID_CARD: '02307',
  INSUFFICIENT_FUNDS: '02308',
  THREE_DS_AUTH_FAILED: '02310',
  THREE_DS_CANCELLED: '02311',
  SUBSCRIBER_NOT_FOUND: '02401',
  TRANSACTION_NOT_FOUND: '02501',
  THREE_DS_CHALLENGE_REQUIRED: '01131',
};

export default {
  PAYLINE_CURRENCY,
  PAYLINE_ACTIONS,
  PAYLINE_ERROR_CODES,
  gql: {
    GET_BRAND: `
      query GetPaylineBrand($number: String!) {
        paylineGetBrand(number: $number) {
          cardType
          cardCode
        }
      }
    `,
    CAPTURE: `
      mutation PaylineCapture(
        $amount: Int!
        $reference: String!
        $creditCard: PaylineCreditCard!
        $customer: PaylineCustomer
        $id3D: String
      ) {
        paylineCapture(
          amount: $amount
          reference: $reference
          creditCard: $creditCard
          customer: $customer
          id3D: $id3D
        ) {
          transactionId
          token
          authorizationNumber
          resultCode
        }
      }
    `,
    CAPTURE_SUBSCRIBER: `
      mutation PaylineCaptureSubscriber(
        $amount: Int!
        $reference: String!
        $subscriber: PaylineSubscriber!
      ) {
        paylineCaptureSubscriber(
          amount: $amount
          reference: $reference
          subscriber: $subscriber
        ) {
          transactionId
          token
          authorizationNumber
          resultCode
          needs3DS
          threeDSData {
            actionUrl
            actionMethod
            pareq
            pareqFieldName
            pareqFieldValue
            md
            mdFieldName
            mdFieldValue
            termUrl
            mpiResult
            transientData
          }
        }
      }
    `,
    CAPTURE_SUBSCRIBER_AFTER_3DS: `
      mutation PaylineCaptureSubscriberAfter3DS(
        $amount: Int!
        $reference: String!
        $walletId: String!
        $pares: String!
        $md: String!
      ) {
        paylineCaptureSubscriberAfter3DS(
          amount: $amount
          reference: $reference
          walletId: $walletId
          pares: $pares
          md: $md
        ) {
          transactionId
          token
          authorizationNumber
          resultCode
        }
      }
    `,
    SUBSCRIBE: `
      mutation PaylineSubscribe(
        $amount: Int!
        $uuid: String!
        $reference: String!
        $creditCard: PaylineCreditCard!
        $customer: PaylineCustomer
        $id3D: String
      ) {
        paylineSubscribe(
          amount: $amount
          uuid: $uuid
          reference: $reference
          creditCard: $creditCard
          customer: $customer
          id3D: $id3D
        ) {
          transactionId
          token
          authorizationNumber
          resultCode
        }
      }
    `,
    SUBSCRIBE_AND_CAPTURE: `
      mutation PaylineSubscribeAndCapture(
        $amount: Int!
        $uuid: String!
        $reference: String!
        $creditCard: PaylineCreditCard!
        $customer: PaylineCustomer
        $id3D: String
      ) {
        paylineSubscribeAndCapture(
          amount: $amount
          uuid: $uuid
          reference: $reference
          creditCard: $creditCard
          customer: $customer
          id3D: $id3D
        ) {
          transactionId
          token
          authorizationNumber
          resultCode
        }
      }
    `,
    CAPTURE_WITH_TOKEN: `
      mutation PaylineCaptureWithToken(
        $amount: Int!
        $token: String!
        $uuid: String!
        $reference: String!
        $customer: PaylineCustomer
      ) {
        paylineCaptureWithToken(
          amount: $amount
          token: $token
          uuid: $uuid
          reference: $reference
          customer: $customer
        ) {
          transactionId
          token
          authorizationNumber
          resultCode
          maskedCardNumber
          cardBrand
          cardCountry
          expiryDate
          walletId
        }
      }
    `,
    GET_TOKEN: `
      mutation PaylineGetToken(
        $amount: Int!
        $reference: String!
        $returnUrl: String!
        $cancelUrl: String!
        $callbackUrl: String
        $customer: PaylineCustomer
        $currency: String
        $walletId: String
        $action: String
        $deliveryIntent: String
      ) {
        paylineGetToken(
          amount: $amount
          reference: $reference
          returnUrl: $returnUrl
          cancelUrl: $cancelUrl
          callbackUrl: $callbackUrl
          customer: $customer
          currency: $currency
          walletId: $walletId
          action: $action
          deliveryIntent: $deliveryIntent
        ) {
          token
          expiresAt
          widgetUrl
        }
      }
    `,
    CHECK_PAYMENT: `
      query PaylineCheckPayment($token: String!) {
        paylineCheckPayment(token: $token) {
          transactionId
          authorizationNumber
          status
          code
          maskedCardNumber
          cardBrand
          cardCountry
        }
      }
    `,
    RECORD_WIDGET_PAYMENT: `
      mutation PaylineRecordWidgetPayment($orderId: String!, $amount: Int!, $token: String!) {
        paylineRecordWidgetPayment(orderId: $orderId, amount: $amount, token: $token) {
          transactionId
          authorizationNumber
          status
          code
          maskedCardNumber
          cardBrand
          cardCountry
        }
      }
    `,
  },
};
